export default __webpack_public_path__ + "static/media/have fun with text.74244c60.png";